import { API, graphqlOperation, Auth } from "aws-amplify";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";
import { DateTime } from "luxon";

export async function getAllEvents(updateAuthState: Function) {
  let tokens: any;
  try {
    tokens = await Auth.currentSession();
    updateAuthState(true);
  } catch (error) {
    console.error("Unable to load session");
    updateAuthState(false);
    throw error;
  }
  const userName = tokens.getIdToken().payload["cognito:username"];
  let isAdmin = false;
  if (tokens.getAccessToken().payload["cognito:groups"]) {
    isAdmin = tokens
      .getAccessToken()
      .payload["cognito:groups"].includes("Admins");
  }
  let eventArray: any[] = [];
  const singleEvents: any = await API.graphql(
    graphqlOperation(queries.listEvents, {
      limit: 5000,
    })
  );
  const allExternalEvents: any = await API.graphql(
    graphqlOperation(queries.listExternalEvents, {
      limit: 5000,
    })
  );

  singleEvents.data.listEvents.items.forEach((item: any) => {
    let title = "";
    let color = "";
    let borderColor = "white";
    let isOwn = false;
    if (userName === item.user_id) {
      title = "Oma varaus";
      color = stringToColour(item.user_id);
      borderColor = "#616161";
      isOwn = true;
    } else {
      if (isAdmin) {
        title = item.user_email;
        color = stringToColour(item.user_id);
      } else {
        title = "Varattu";
        color = "#616161";
      }
    }

    eventArray.push({
      title: title,
      start: item.valid_from,
      end: item.valid_to,
      id: item.id,
      backgroundColor: color,
      borderColor: borderColor,
      arena_number: item.arena_number,
      isOwn: isOwn,
    });
  });

  allExternalEvents.data.listExternalEvents.items.forEach((item: any) => {
    eventArray.push({
      title: item.title,
      start: item.valid_from,
      end: item.valid_to,
      id: item.id,
      backgroundColor: stringToColour(item.title),
      borderColor: "black",
      arena_number: item.arena_number,
      isOwn: false,
    });
  });

  return eventArray;
}

export async function deleteEvent(eventId: String) {
  const eventDetails = {
    id: eventId,
  };
  await API.graphql(
    graphqlOperation(mutations.deleteEvent, { input: eventDetails })
  );
}

export async function createEvent(
  fromDate: DateTime,
  toDate: DateTime,
  eventName: String,
  arenaNumber: Number
) {
  const tokens = await Auth.currentSession();
  const userName = tokens.getIdToken().payload["cognito:username"];
  const eventDetails = {
    user_id: userName,
    user_email: eventName,
    valid_from: fromDate,
    valid_to: toDate,
    arena_number: arenaNumber,
  };

  await API.graphql(
    graphqlOperation(mutations.createEvent, { input: eventDetails })
  );
}

const stringToColour = function (str: String) {
  if (str === null) return "#00000";
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = "#";
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    colour += ("00" + value.toString(16)).substr(-2);
  }
  return colour;
};
